interface Player {
  id: number;
  name: string;
  lastName: string;
  gender: string;
  memberNumber: string;
  birthDate: string;
  pending?: boolean;
}

export const formatDate = (dateString: string): string => {
  if (!dateString) return '';
  const [datePart] = dateString.split('T');
  const [year, month, day] = datePart.split('-');
  if (!(year && month && day)) return 'Kein Heimspiel';
  return `${day}.${month}.${year}`;
};

export const birthDate2age = (birthDate: string): number => {
  if (!birthDate) return 0;
  const today = new Date();
  const birthDateObj = new Date(birthDate);
  let age = today.getFullYear() - birthDateObj.getFullYear();
  const monthDiff = today.getMonth() - birthDateObj.getMonth();
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDateObj.getDate())
  ) {
    age--;
  }
  return age;
};

export const countGender = (players: Player[], gender: string): number => {
  return players.filter((player) => player.gender === gender).length;
};
